module.exports = __webpack_public_path__ + "static/media/branding-img9.e5237bc0.jpg";